/* Dharvi product page: free-shipping progress + mobile sticky Add to cart bar. */
(function () {
  var money = function (n) { return '₹' + Math.round(n).toLocaleString('en-IN'); };

  /* ---------- free shipping progress (reads the cart) ---------- */
  function paintShipping(totalRupees) {
    document.querySelectorAll('[data-dh-fs]').forEach(function (box) {
      var t = parseFloat(box.getAttribute('data-threshold')) || 3000;
      var txt = box.querySelector('[data-dh-fs-text]');
      var bar = box.querySelector('[data-dh-fs-bar]');
      if (!txt || !bar) return;
      if (totalRupees <= 0) {
        txt.innerHTML = 'Free shipping on orders of <strong>' + money(t) + '+</strong> in India';
        bar.style.width = '0';
      } else if (totalRupees >= t) {
        txt.innerHTML = '<strong>You’ve unlocked free shipping</strong> in India';
        bar.style.width = '100%';
      } else {
        txt.innerHTML = 'Add <strong>' + money(t - totalRupees) + '</strong> more for free shipping in India';
        bar.style.width = Math.min(100, (totalRupees / t) * 100) + '%';
      }
    });
  }
  function refreshShipping() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { paintShipping((c.total_price || 0) / 100); })
      .catch(function () {});
  }
  refreshShipping();
  try {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, refreshShipping);
    }
  } catch (e) {}

  /* ---------- sticky add-to-cart bar (phones) ---------- */
  var bar = document.querySelector('[data-dh-sticky]');
  var form = document.querySelector('product-form form');
  var submit = form && form.querySelector('button[type="submit"]');
  if (!bar || !submit) return;

  var priceEl = bar.querySelector('[data-dh-sticky-price]');
  var btn = bar.querySelector('[data-dh-sticky-btn]');
  function syncPrice() {
    var src = document.querySelector('.product__info-container .price-item--last');
    if (src && priceEl) priceEl.textContent = src.textContent.trim();
  }
  function syncState() {
    var off = submit.disabled || submit.hasAttribute('aria-disabled');
    btn.disabled = off;
    var label = submit.querySelector('span');
    btn.textContent = label ? label.textContent.trim() : 'Add to cart';
  }
  syncPrice(); syncState();
  var info = document.querySelector('.product__info-container');
  if (info && window.MutationObserver) {
    new MutationObserver(function () { syncPrice(); syncState(); })
      .observe(info, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
  }
  btn.addEventListener('click', function () { submit.click(); });

  var ticking = false;
  function check() {
    ticking = false;
    var gone = submit.getBoundingClientRect().bottom < 0;
    bar.classList.toggle('is-visible', gone);
    document.body.classList.toggle('dh-sticky-on', gone);
  }
  function onScroll() {
    if (!ticking) { ticking = true; requestAnimationFrame(check); }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  check();
})();
